import { useEffect, useState } from "react";
import { Grid, Placeholder, Table, TableRow } from "semantic-ui-react";
import { CommonTable, CustomButton, InputText } from "../../components";

import { format } from "date-fns";
import { useForm } from "react-hook-form";
import { useAcceptDrawingRequest, useGetSupplierDrawingRequests } from "../../api/notification";
import ConfirmModal from "../../components/confirmViewModal/ConfirmModal";
import PaginationView from "../../components/pagination/Pagination";
import { MappingInteractionState } from "../../config/enums/SupplierRequestStatus.enum";
import { NotificationCol } from "../../config/tableColConstant";
import { useAuthContext } from "../../hooks/useAuthContext";
import ShareMappingConfirm from "./SupplierShareMappingConfirm";
import MappingRepliesFilter from "./filters/MappingRepliesFilter";

const MappingReplies = ({ currentAvailableMappingReply = () => {} }: any) => {
  const [notification, setNotificationAction] = useState(null);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [pageLimit, setPageLimit] = useState<any>(10);
  const [mappingModal, setMappingModal] = useState<any>(false);
  const [requestId, setRequestId] = useState(null);
  const [ingredientId, setIngredientId] = useState(null);
  const [sortBy, setSortBy] = useState<number>(0);
  const [filterProductIds, setFilterProductIds] = useState([]);
  const [searchKey, setSearchKey] = useState<string>("");

  const { register, watch } = useForm();
  const [searchRequest] = watch(["searchRequest"]);

  const { newNotification, dispatch } = useAuthContext();

  const {
    data: drawingRequests,
    isLoading: isNotificationLoading,
    refetch
  } = useGetSupplierDrawingRequests(
    newNotification,
    pageNumber,
    pageLimit,
    searchRequest,
    filterProductIds,
    sortBy
  );

  const refetchWithFilters = (newProductIds: [], sortBy: number) => {
    setFilterProductIds(newProductIds);
    setSortBy(sortBy);
  };

  const result = drawingRequests?.result || [];

  const { mutate } = useAcceptDrawingRequest();

  useEffect(() => {
    if (result) {
      currentAvailableMappingReply(result);
    }
  }, [result]);

  useEffect(() => {
    refetch();
  }, []);
  const handlePagination = (currentPage: any) => {
    setPageNumber(currentPage);
  };

  const handlePageSize = (pageSize: any) => {
    setPageLimit(pageSize);
  };

  const onApproveRequest = () => {
    mutate(
      {
        id: notification,
        data: {
          isAccepted: true
        }
      },
      {
        onSuccess: () => {
          dispatch({
            type: "NEW_NOTIFICATION"
          });
          setNotificationAction(null);
        },
        onError: () => {
          setNotificationAction(null);
        }
      }
    );
  };

  const openShareMapping = (data: any) => {
    setRequestId(data._id);
    setIngredientId(data.ingredientId);
    setMappingModal(true);
  };

  const getAcceptDate = (status: [number, string][]) => {
    if (!Array.isArray(status)) return null;
    const acceptState = status.find((item: [number, string]) => {
      return item[0] === MappingInteractionState.Accepted;
    });
    const acceptTime = acceptState ? acceptState[1] : new Date();
    return format(new Date(acceptTime), "dd/MM/yyyy");
  };

  const getSharedTime = (data: any) => {
    const status: [number, string][] = data.status;
    if (!Array.isArray(status)) return null;
    const sharedStatus = status
      .filter((item: [number, string]) => {
        return item[0] === MappingInteractionState.Completed;
      })
      .sort();

    if (sharedStatus[0]) {
      return (
        <Grid>
          <Grid.Row>
            <p>
              {format(new Date(sharedStatus[0][1]), "dd/MM/yyyy")} |{" "}
              <a
                href="javascript:void(0)"
                onClick={() => {
                  openShareMapping(data);
                }}
              >
                Share mapping again
              </a>
            </p>
          </Grid.Row>
        </Grid>
      );
    }

    return (
      <CustomButton
        theme="green"
        buttonOutLine
        title="Share mapping"
        onClick={() => {
          openShareMapping(data);
        }}
      />
    );
  };

  const loadTableData = () => {
    if (isNotificationLoading) {
      return (
        <>
          {[...Array(5)].map((_, i) => (
            <TableRow key={i}>
              <Table.Cell colSpan={7}>
                <Placeholder>
                  <Placeholder.Line length="full" />
                  <Placeholder.Line length="very long" />
                </Placeholder>
              </Table.Cell>
            </TableRow>
          ))}
        </>
      );
    }
    return result?.map((data: any, index: any) => {
      return (
        <Table.Row className="tbleR" key={index}>
          <Table.Cell>
            <p>{data?.ingredients?.ingredient_name}</p>
          </Table.Cell>
          <Table.Cell>
            <p>{data?.tenants?.name}</p>
          </Table.Cell>
          <Table.Cell>
            <p>{data?.concatenatedSalesName}</p>
          </Table.Cell>

          <Table.Cell>
            {data.isAccepted ? (
              <p>{getAcceptDate(data.status)}</p>
            ) : (
              <CustomButton
                theme="green"
                buttonOutLine
                title="Accept Request"
                onClick={() => {
                  setNotificationAction(data._id);
                }}
              />
            )}
          </Table.Cell>
          <Table.Cell>{data.isAccepted ? getSharedTime(data) : null}</Table.Cell>
        </Table.Row>
      );
    });
  };

  return (
    <>
      <Grid>
        <Grid.Column computer={16} tablet={16} mobile={16}>
          {" "}
          <Grid>
            <Grid.Column computer={4} textAlign="left">
              <InputText
                register={register}
                name="searchRequest"
                placeholder="Search Request"
                defaultValues={searchKey}
                onChangeFunction={(e: any) => {
                  setSearchKey(e.target.value);
                }}
              />
            </Grid.Column>
            <Grid.Column computer={2}>
              <MappingRepliesFilter refetchWithFilters={refetchWithFilters} />
            </Grid.Column>
          </Grid>
        </Grid.Column>
        <Grid.Column computer={16} tablet={16} mobile={16}>
          <CommonTable singleLine tableHeaderData={NotificationCol}>
            {loadTableData()}
          </CommonTable>
          <PaginationView
            changePageSize={handlePageSize}
            pageSize={pageLimit}
            totalPages={Math.ceil((drawingRequests?.total || 0) / pageLimit) || 1}
            currentPageNo={pageNumber}
            currentSelectPage={handlePagination}
          />
        </Grid.Column>
      </Grid>
      <ShareMappingConfirm
        visibleModal={mappingModal}
        setVisibleModal={() => {
          setMappingModal(false);
        }}
        requestId={requestId}
        ingredientId={ingredientId}
      />
      <ConfirmModal
        viewModal={!!notification}
        closeModal={() => setNotificationAction(null)}
        cancel={() => {
          setNotificationAction(null);
        }}
        approve={() => {
          onApproveRequest();
        }}
        title={`Submit notification request`}
        subTitle={`Are you sure you want to submit request?`}
      />
    </>
  );
};

export default MappingReplies;
